import axios from 'axios';
import { apiConnector } from './apiconnector';
// import { addUserPoints } from './gamesAPI';

const BASE_URL = process.env.REACT_APP_API_URL;

// export const getImageDescriptionFromUrl = async (imageUrl) => {
//   try {
//     const response = await apiConnector("POST",`${BASE_URL}/observations/image-caption-from-url`, {
//       imageUrl,
//     });

//     return response
//   } catch (error) {
//     console.error('Error getting image description:', error.message);
//     return '';
//   }
// };

export const approveResponse = async (observationId) => {
  try {
    const token = localStorage.getItem('token');

    const response = await apiConnector(
      'PUT',
      `${BASE_URL}/observations/${observationId}/approve`,
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    // await addUserPoints(response.observations.responseData.responsiblePerson, 2);
    return response;
  } catch (error) {
    console.error('Error approving response:', error);
    throw error;
  }
};

export const rejectResponse = async (observationId, rejectionReason) => {
  try {
    const token = localStorage.getItem('token');

    const response = await apiConnector(
      'PUT',
      `${BASE_URL}/observations/${observationId}/reject`,
      { rejectionReason },
      {
        Authorization: `Bearer ${token}`,
      }
    );

    return response;
  } catch (error) {
    console.error('Error rejecting response:', error);
    throw error;
  }
};

export const submitObservationResponse = async (observationId, data) => {
  try {
    const token = localStorage.getItem('token');

    const response = await apiConnector(
      'POST',
      `${BASE_URL}/observations/submit-response/${observationId}`,
      data,
      {
        Authorization: `Bearer ${token}`,
      }
    );
    // await addUserPoints(data.userId, 4);
    return response;
  } catch (error) {
    console.error('Error submitting response:', error);
    throw error;
  }
};


export const addCorrectiveAction = async (observationId, data) => {
  try {
    const token = localStorage.getItem("token");

    const response = await apiConnector(
      "POST",
      `${BASE_URL}/observations/add-action/${observationId}`,
      data,
      {
        Authorization: `Bearer ${token}`,
      }
    );
    
    return response;
  } catch (error) {
    console.error("Error adding corrective action:", error);
    throw error;
  }
};

export const getDashboardActivity = async () => {
  try {
    const token =localStorage.getItem("token")

    const response = await apiConnector("GET",`${BASE_URL}/observations/activity`,null, 
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (error) {
    console.error('Error fetching observations:', error);
    throw error;
  }
 
};

export const getObservationsByArea = async (areaId) => {
  try {
    const token = localStorage.getItem('token');
    
    const response = await apiConnector(
      'GET',
      `${BASE_URL}/observations/area/${areaId}`,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (error) {
    console.error('Error fetching observations by area:', error);
    throw error;
  }
};

export const getObservations = async () => {
  try {
    const token =localStorage.getItem("token")

    const response = await apiConnector("GET",`${BASE_URL}/observations/`,null, 
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (error) {
    console.error('Error fetching observations:', error);
    throw error;
  }
};
export const getActions = async () => {
    try {
      const token =localStorage.getItem("token")
  
      const response = await apiConnector("GET",`${BASE_URL}/actions`,null, 
        { Authorization: `Bearer ${token}` }
      );
      return response;
    } catch (error) {
      console.error('Error fetching actions:', error);
      throw error;
    }
  };
  export const getUsers = async () => {
    try {
      const token =localStorage.getItem("token")
  
      const response = await apiConnector("GET",`${BASE_URL}/observations/get-users`,null, 
        { Authorization: `Bearer ${token}` }
      );
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };
  export const getUserCompanyById = async (id) => {
    try {
      const token =localStorage.getItem("token")
  
      const response = await apiConnector("GET",`${BASE_URL}/users/${id}`,null, 
        { Authorization: `Bearer ${token}` }
      );
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };
  export const getAreas = async () => {
    try {
      const token =localStorage.getItem("token")
  
      const response = await apiConnector("GET",`${BASE_URL}/areas`,null, 
        { Authorization: `Bearer ${token}` }
      );
      return response;
    } catch (error) {
      console.error('Error fetching observations:', error);
      throw error;
    }
  };
  export const getAreasWithId = async (id) => {
    try {
      const token =localStorage.getItem("token")
  
      const response = await apiConnector("GET",`${BASE_URL}/areas/${id}`,null, 
        { Authorization: `Bearer ${token}` }
      );
      return response;
    } catch (error) {
      console.error('Error fetching observations:', error);
      throw error;
    }
  };

  export const getMyObservations = async () => {
    const token = localStorage.getItem('token');
  
    const response = await apiConnector(
      'GET',
      `${BASE_URL}/observations/my-observations`,
      null,
      { Authorization: `Bearer ${token}` }
    );
  
    return response;
  };
  
  export const getMyAssignedObservations = async () => {
    const token = localStorage.getItem('token');
  
    const response = await apiConnector(
      'GET',
      `${BASE_URL}/observations/my-assigned-observations`,
      null,
      { Authorization: `Bearer ${token}` }
    );
  
    return response;
  };


  export const createObservation = async (observationData) => {
    try {
      const token = localStorage.getItem('token');
  
      const response = await apiConnector(
        'POST',
        `${BASE_URL}/observations`,
        observationData,
        {
          Authorization: `Bearer ${token}`,
        }
      );
      // await addUserPoints(response.observedBy, 5);
      return response;
    } catch (error) {
      console.error('Error creating observation:', error);
      throw error;
    }
  };